import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

import './index.scss'
import { useContext, useEffect, useState } from "react";
import Loading from "components/Loading";
import contratoService from "services/ContratoService";
import SaldoItens from "./SaldoItens";
import FinanceiraConsorcio from "./FinanceiraConsorcio";
import PorPrioridade from "./PorPrioridade";
import PorPrazo from "./PorPrazo";
import dashboardService from "services/DashboardService";
import Calendario from "./Calendario";
import AppContext from "AppContext";
import { PapelEnum, ehPapelGestorContrato } from "services/PerfilService";

const Dashboard = (props) => {
  const [contratos, setContratos] = useState()
  const [dados, setDados] = useState()
  const [idContrato, setIdContrato] = useState()
  const { state } = useContext(AppContext)

  const podeSelecionarContrato = !ehPapelGestorContrato(state.user?.perfil?.idTipo)
    && state.user?.perfil?.idTipo != PapelEnum.FISCAL
    && state.user?.perfil?.idTipo != PapelEnum.GESTOR_EMPRESA

  useEffect(() => {
    if (!state.user)
      return

    if (podeSelecionarContrato) {
      dashboardService.contrato().then(res => {
        if (res.success) {
          setContratos(res.data)
        }
      })
    } else {
      if (state.contrato) {
        setContratos([])
        setIdContrato(state.contrato.id)
      }
    }
  }, [state.contrato])

  const carregar = () => {
    setDados()
    if (!idContrato)
      return
    dashboardService.gerar(idContrato).then(res => {
      if (res.success)
        setDados(res.data)
    })
  }

  useEffect(() => {
    console.log({ idContrato })
    carregar()
  }, [idContrato])

  if (!contratos)
    return <></>

  return (
    <Container fluid className="mt-4 dashboard">
      <Row>
        {(podeSelecionarContrato) && (
          <Col xs={4}>
            <select
              className="form-control"
              value={idContrato || ''}
              onChange={(ev) => setIdContrato(ev.target.value != '' ? +ev.target.value : undefined)}
            >
              <option value="">Selecione o contrato</option>
              {contratos.map(el => (
                <option key={el.id} value={el.id}>{el.numero}</option>
              ))}
            </select>
          </Col>
        )}
        <Col>
          {idContrato && (
            <Button color="primary" onClick={() => carregar()}>
              <i className="bi bi-arrow-clockwise"></i>
            </Button>
          )}
        </Col>
      </Row>
      {dados && (
        <>
          <Card className="mt-4">
            <CardBody>
              {dados.contrato.consorcioEmpresa == 'C' ? (
                <>
                  <strong>Consórcio:</strong> {dados.contrato.consorcio.nome}
                </>
              ) : (
                <>
                  <strong>Empresa:</strong> {dados.contrato.empresa.razaoSocial}
                </>
              )}
            </CardBody>
          </Card>
          <Calendario dados={dados.calendario} />
          <SaldoItens dados={dados.saldoItens} />
          {dados.distribuicaoConsorcio && (
            <FinanceiraConsorcio dados={dados.distribuicaoConsorcio} />
          )}
          <Row>
            <Col>
              <PorPrioridade dados={dados.porPrioridade} />
            </Col>
            <Col>
              <PorPrazo dados={dados.porPrazo} />
            </Col>
          </Row>
        </>
      )
      }

    </Container >
  );
};

export default Dashboard
